import React from 'react';
import { Box, useTheme } from '@mui/material';
import { useAtomValue } from 'jotai';
import { ParentSize } from '@visx/responsive';
import BarChart from '../../../../Components/Charts/BarChart';
import { themeAtom } from '../../../../Atoms';
import TooltipContent from './TooltipContent';
// import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
// import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

const UsersCountersWidget = function UsersCountersWidget({ userCounters }) {
  const theme = useTheme();
  const currentTheme = useAtomValue(themeAtom);

  const branches = userCounters?.map(({ name }) => name);

  const performedCallsData = userCounters?.map((d, index) => ({
    index: index + 1,
    label: d?.name,
    [d?.name]: d?.callCount, //branch with his calls
    details: d?.details,
  }));

  const answeredCallsData = userCounters?.map((d, index) => ({
    index: index + 1,
    label: d?.name,
    [d?.name]: d?.answeredCallCount, //branch with his answered calls
    details: d?.details,
    target: d?.target,
  }));

  return (
    <>
      <Box
        sx={{
          width: "auto",
          height: "40vh"
        }}>
        <ParentSize>
          {(parent) => (
            //parent component passes his css properties to BarChart
            (<BarChart
              width={parent.width}
              height={parent.height}
              dataToShow={[performedCallsData, answeredCallsData]}
              keys={branches}
              colors={theme.custom
                .generateConsistentUniqueColors(branches)
                ?.map((x) => x[currentTheme])}
              showTarget
              TooltipContent={TooltipContent}
              minTickWidth={160}
              renderTargetIcon={({ x, y, target, value, index }) => {
                const size = 30;
                const reached = value >= target;
                return (
                  // <foreignObject
                  //   x={x - size / 2}
                  //   y={y - size / 2}
                  //   width={size}
                  //   height={size}
                  // >
                  //   {reached ? (
                  //     <CheckCircleRoundedIcon
                  //       color="success"
                  //       sx={{ fontSize: size }}
                  //     />
                  //   ) : (
                  //     <CancelRoundedIcon
                  //       color="error"
                  //       sx={{ fontSize: size }}
                  //     />
                  //   )}
                  // </foreignObject>
                  <text
                    key={`target-user-icon-${index}`}
                    x={x - size / 2}
                    y={y + size / 2 - 2}
                    textAnchor="middle"
                    fontSize={size}
                    fontWeight="bold"
                    fill={
                      reached
                        ? theme.palette.success.main
                        : theme.palette.error.main
                    }
                  >
                    {reached ? '✓' : '✗'}
                  </text>
                );
              }}
            />)
          )}
        </ParentSize>
      </Box>
    </>
  );
};

export default UsersCountersWidget;
